<div class="d-flex flex-wrap justify-content-between mt-5">
  <div class="content-section">
    <div [innerHTML]="sanitizedHtml"></div>
  </div>
  <div class="image-section position-relative">
    <cx-media [container]="imageData" class="img-styles" loading="lazy" />
    <!-- <div class="centered-text">{{overlayText}}<span class="tm-symbol">™</span></div> -->
  </div>
</div>